module.exports = __webpack_public_path__ + "static/media/juice.114a4c91.svg";